export class TankCoverageArea {
  Tank_ID: number;
  Top_Size: string;
  Bottom_Size: string;
  Depth: number;
  Water_Capacity: number;
  Total_Cost: number;
  Coverage_Area: number;
  Created_Dt: string;
  Active: true;
}
export interface ApplicationBankDetials {
  accoHolderName: string;
  accoNumber: string;
  active: string;
  bankName: string;
  bankPath: string;
  bankShortName: string;
  farmerID: string;
  ifcsCode: string;
}

export class ApplicationSolarPumpDetails {
  controlerType: string;
  farmerShare: number;
  primaryVendor: string;
  pumpCapacity: string;
  pumpCategory: string;
  secondaryVendor: string;
  type: string;
}

export class ApplicationPondData {
  bottomSize: string;
  dept: number;
  killaNo: number;
  latitude: string;
  longitude: string;
  morabbaNo: number;
  topSize: string;
  totalCost: number;
  waterCapacity: number;
}
export interface ApplicationMemberDetails {
  Aadhaar_Copy_Upload: string;
  Aadhar_No: string;
  Active: string;
  Address: string;
  Area_Already_Apply: '0';
  Caste_Code: string;
  DOB: string;
  Dt_Entered: string;
  Dt_Update: string;
  Email_ID: string;
  Farmer_ID: string;
  Farmer_Photo: string;
  Father_name: string;
  Gender: string;
  ID_Proof_FilePath: string;
  Mobile: string;
  Mother_Name: string;
  Name: string;
  PPP_ID: string;
  Pin_Code: string;
  Village_Code: string;
  memberID: number;
  District: string;
  Block: string;
  MFMBNo: string
}
export class ApplicationFarmerLandDetails {
  cropType: string;
  farmerId: string;
  killaNo: number;
  landPath: string;
  memberID: number;
  morabbaNo: number;
  totalArea: string;
  Village: string;
}
export class ApplicationWaterCourseDetails{
  Canal_Outlet_Name: string;
  Outlet_Code: string;
  RD: string;
  WorkTypeName?: string;
  Work_type?: string;
}

export class ApplicationMIDetails {
  appID: string;
      programName: string;
      landData: string;
      miVendorName: string;
      totalArea: string;
}
export class ApplicationDetailsModel {
  APP_ID: string;
  ConsentPath: string;
  Scheme_Code: string;
  FarmerBank: ApplicationBankDetials;
  Solar_Pump_Datas: ApplicationSolarPumpDetails[];
  OnFarm_Pond_Datas: ApplicationPondData[];
  Group_Datas: ApplicationMemberDetails[];
  FarmerLand: ApplicationFarmerLandDetails[];
  Water_Course_Datas: ApplicationWaterCourseDetails[];
  New_MI_Datas: ApplicationMIDetails[];
  FarmerPersonalData: ApplicationMemberDetails;
  FincialYear: string;
  RegDate: string;
  VillageData: any;
  MFMBNo: any;
  AppType: any;
}
